import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { inject, observer } from 'mobx-react';
import DataGrid, {
  Button as DGButton,
  Column,
  FilterRow,
  FilterPanel,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  DataGridTypes,
  Export
} from 'devextreme-react/data-grid';
import { ColumnChooser } from 'devextreme-react/cjs/tree-list';

import styled from '@emotion/styled';
import { Button, Intent, Spinner, Tooltip, Label, Dialog, Checkbox } from '@blueprintjs/core';
import { Message } from '../../store/models/Message';
import { Pharmacy } from '../../store/models/Pharmacy';
import { Group } from '../../store/models/Group';
import { MessageStore } from '../../store';
import { SendingEventExtStore } from '../../store';
import { PharmacyStore } from '../../store';
import { AuthenticationStore } from '../../store';
import { MessageDialog } from '../common/MessageDialog';
import { IconNames } from '@blueprintjs/icons';
import moment from 'moment';
import DateInput from '../common/input/DateInput';
import { TranslatedMessage } from '../common/translation';
import { TextInput } from '../common/input/basicInputs';
import GroupSelection from '../common/dropdownSelection/GroupSelection';
import PharmacySelection from '../common/dropdownSelection/PharmacySelection';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';

interface MessageTabProps extends WithTranslateProps {
  secretariatId?: number;
  pharmacyId?: number;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  groupList: Array<Instance<typeof Group>>;
  MessageStore?: Instance<typeof MessageStore>;
  SendingEventExtStore?: Instance<typeof SendingEventExtStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
}

interface MessageTabState {
  newMessage?: any;
  isTestMessage: boolean;
  isMessageDialogOpen: boolean;
  preview?: any;
  currentMessage?: any;
  messageList: Array<Instance<typeof Message>>;
  isLoading: boolean;
  dutyDate?: Date;
  dutyType?: string;
  isDayOnlyChecked?: boolean;
  dateFrom: Date;
  dateTo: Date;
  recipient?: string;
  subject?: string;
  isBodyDisplayDialogOpen: boolean;
  body: string;
  oneDay: boolean;
  showAllEventTypes: boolean;
  pharmacyId?: number;
  secretariatId?: number;
  groupId?: number;
}

const calculateCustomSummary = (options) => {
  // Calculating "customSummary1"
  if (options.name == "title") {
    switch (options.summaryProcess) {
      case "start":
        // Initializing "totalValue" here
        break;
      case "calculate":
        // Modifying "totalValue" here
        options.totalValue = options.value.messageId + '  ' + options.value.title + '  ' + options.value.body;
        break;
      case "finalize":
        // Assigning the final value to "totalValue" here
        //options.totalValue = options.value;
        break;
    }
  }
}

@inject('MessageStore', 'SendingEventExtStore', 'AuthenticationStore', 'PharmacyStore')
@observer
class MessageTabV4 extends React.Component<MessageTabProps, MessageTabState> {
  state = {
    isLoading: false,
    newMessage: undefined,
    preview: '',
    messageList: [],
    isTestMessage: false,
    isMessageDialogOpen: false,
    dateFrom: new Date(),
    dateTo: new Date(),
    isBodyDisplayDialogOpen: false,
    body: '',
    oneDay: true,
    showAllEventTypes: false,
    pharmacyId: undefined,
    secretariatId: undefined,
    groupId: undefined,
  } as MessageTabState;

  _isMounted = false;

  createMarkup = (text) => {
    return { __html: text };
  };

  tooltipRenderer = (text) => {
    const content = '<span dangerouslySetInnerHTML={__html: ' + text.value + '}></span>';
    return content;
  };

  componentDidMount = async () => {
    this._isMounted = true;
    await this.props.PharmacyStore!.checkListLoaded();
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  buildGridData = () => {
    const { messageList, showAllEventTypes } = this.state;

    let data: any[];

    if (showAllEventTypes) {
      data = messageList;
    } else {
      data = Object.values(
        messageList.reduce((acc, event) => {
          const { sendingId, eventType, timestamp } = event;
          const key = `${sendingId}-${eventType}`;
          const currentTimestamp = new Date(timestamp!).getTime();

          if (!acc[key] || currentTimestamp < new Date(acc[key].timestamp).getTime()) {
            acc[key] = event;
          }

          return acc;
        }, {} as Record<string, any>)
      );
    }

    return data.map((msg) => ({
      messageId: msg.messageId,
      title: msg.title,
      body: msg.body,
      createdOn: msg.createdOn,
      messageCreatedOn: msg.messageCreatedOn,
      recipientMailAddress: msg.recipientMailAddress,
      eventType: msg.eventType,
      timestamp: msg.timestamp,
      sendingId: msg.sendingId,
      apbNumber: msg.apbNumber,
      messageType: msg.messageType
    }));
  };

  showBody = (data) => {
    this.setState({ isBodyDisplayDialogOpen: true, body: data });
  };

  hideBody = () => {
    this.setState({ isBodyDisplayDialogOpen: false });
  };

  newMessage = () => {
    this.setState({ isTestMessage: false, isMessageDialogOpen: true });
  };

  testMessage = () => {
    this.setState({ isTestMessage: true, isMessageDialogOpen: true });
  };

  stopEdition = () => {
    this._isMounted && this.setState({ isMessageDialogOpen: false });
  };

  private onRowClicked = (ev) => {
    this.setState({ preview: ev.data.body, currentMessage: ev.data });
  };

  loadMessage = async () => {
    this._isMounted && this.setState({ isLoading: true });
    const criteriaMessage: any = {
      secretariatId: this.props.secretariatId === undefined ? this.state.secretariatId : this.props.secretariatId,
      pharmacyId: this.props.pharmacyId === undefined ? this.state.pharmacyId : this.props.pharmacyId,
      groupId: this.state.groupId,
      from: this.state.dateFrom,
      to: this.state.dateTo,
      recipient: this.state.recipient,
      subject: this.state.subject
    };
    const res: any = await this.props.SendingEventExtStore!.searchSendingEventExt(criteriaMessage);
    this._isMounted && this.setState({ messageList: res });
    this._isMounted && this.setState({ isLoading: false });
  };

  save = async (newMessage: any) => {
    this.stopEdition();
    if (this.state.isTestMessage) newMessage.selectionMode = 'test';
    await this.saveMessage(newMessage);
  };

  saveMessage = async (data: any) => {
    await this.props.MessageStore!.sendMessage(data);
    await this.loadMessage();
  };

  sendPreview = (data: any) => {
    const res = (this.props.MessageStore!.sendPreview(data) as unknown) as boolean;
    this.loadMessage();
    return res;
  };

  dateFromSearchChange = (date) => {
    this.setState({ dateFrom: date });
  };

  dateToSearchChange = (date) => {
    this.setState({ dateTo: date });
  };

  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Messages.xlsx');
      });
    });
  };

  render() {
    const { translate, pharmacyId, pharmacyList, groupList, secretariatId, PharmacyStore } = this.props;
    const { isLoading, dateFrom, dateTo, recipient, subject } = this.state;
    const isSecretariat = this.props.AuthenticationStore!.isSecretariat;

    const onCloneIconClick = (e) => {
      this.props.MessageStore!.resendMessage(e.row.data.sendingId);
      e.event.preventDefault();
    };

    const cellRenderer = (data: DataGridTypes.ColumnCellTemplateData) => {
      return (
        <>
          {data.value}
          <DGButton
            text="Montrer"
            hint="Montrer"
            icon="search"
            visible={true}
            disabled={false}
            onClick={() => onShowBodyClick(data.value)}
          />
        </>
      );
    };


    const onShowBodyClick = (e) => {
      this.showBody(e.row.data.body);
    };

    const onCloseBodyClick = (e) => {
      this.hideBody();
    };

    const body = JSON.stringify(this.state.body);

    return (
      <Container>
        <Dialog
          isOpen={this.state.isBodyDisplayDialogOpen}
          icon={IconNames.EDIT}
          title={<TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate} />}
          onClose={onCloseBodyClick}
          style={{ width: '1400px' }}
          canOutsideClickClose={false}
        >
          <div dangerouslySetInnerHTML={{ __html: this.state.body }} />
        </Dialog>

        <DivLine>
          <DivColumn>
            <DivLine>
              <Label style={{ marginRight: '10px' }}>{translate(TLCode.StartDate)}</Label>
              <Tooltip content={translate(TLCode.GENERAL_PreviousDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  small={true}
                  style={{ height: '30px', marginRight: '5px' }}
                  onClick={() => {
                    console.time('otherDayClicked');
                    const date = moment(this.state.dateFrom)
                      .startOf('day')
                      .subtract(1, 'd')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <DateInput
                value={dateFrom}
                canClearSelection={false}
                onChange={(value) => {
                  this.dateFromSearchChange(value);
                  if (this.state.oneDay) {
                    this.dateToSearchChange(value);
                  }
                }}
              />
              <Tooltip content={translate(TLCode.GENERAL_NextDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    console.time('otherDayClicked');
                    const date = moment(this.state.dateFrom)
                      .startOf('day')
                      .add(1, 'd')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <Tooltip content={translate(TLCode.GENERAL_Today)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.DOUBLE_CHEVRON_DOWN}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(new Date())
                      .startOf('day')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <Checkbox
              name="OneDay"
              checked={this.state.oneDay}
              onChange={(event) => this.setState({ oneDay: event.currentTarget.checked })}
            >
              <TranslatedMessage id={TLCode.MESSAGE_OneDay} />
            </Checkbox>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <Label style={{ marginRight: '10px' }}>{translate(TLCode.EndDate)}</Label>
              <Tooltip content={translate(TLCode.GENERAL_PreviousDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  small={true}
                  style={{ height: '30px', marginRight: '5px' }}
                  onClick={() => {
                    console.time('otherDayClicked');
                    const date = moment(this.state.dateTo)
                      .endOf('day')
                      .subtract(1, 'd')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <DateInput
                value={dateTo}
                canClearSelection={false}
                onChange={(value) => {
                  this.dateToSearchChange(value);
                  if (this.state.oneDay) {
                    this.dateFromSearchChange(value);
                  }
                }}
              />
              <Tooltip content={translate(TLCode.GENERAL_NextDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    console.time('otherDayClicked');
                    const date = moment(this.state.dateTo)
                      .endOf('day')
                      .add(1, 'd')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <Tooltip content={translate(TLCode.GENERAL_Today)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.DOUBLE_CHEVRON_DOWN}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(new Date())
                      .startOf('day')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <DivColumn style={{ width: '60px', textAlign: 'right', paddingRight: '5px' }}>
                <TranslatedMessage id={TLCode.MESSAGE_Recipient} />
              </DivColumn>
              <DivColumn style={{ width: '200px' }}>
                <TextInput
                  name="recipient"
                  value={recipient}
                  required={true}
                  fill={true}
                  onChange={(e) => {
                    this.setState({ recipient: e.target.value });
                  }}
                />
              </DivColumn>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <DivColumn style={{ width: '60px', textAlign: 'right', paddingRight: '5px' }}>
                <TranslatedMessage id={TLCode.MESSAGE_Title} />
              </DivColumn>
              <DivColumn style={{ width: '200px' }}>
                <TextInput
                  name="subject"
                  value={subject}
                  required={true}
                  fill={true}
                  onChange={(e) => {
                    this.setState({ subject: e.target.value });
                  }}
                />
              </DivColumn>
            </DivLine>
          </DivColumn>{' '}
        </DivLine>
        <DivLine style={{ justifyContent: 'flex-start' }}>
          <DivColumn>
            <DivLine>
              <PharmacySelection
                pharmacyList={pharmacyList.filter(
                  (p) => secretariatId === undefined || p.secretariatId === secretariatId,
                )}
                onChange={(p) => this.setState({ pharmacyId: p.pharmacyId })}
                pharmacySelected={pharmacyList.find((p) => p.pharmacyId === this.state.pharmacyId)}
                getPharmacyById={PharmacyStore!.getById}
                allowEmpty={true}
              />
            </DivLine>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <GroupSelection
                style={{ paddingLeft: 10 }}
                groupList={groupList.filter((g) => secretariatId === undefined || g.secretariatId === secretariatId)}
                selectedGroupId={this.state.groupId}
                getGroupById={(id) =>
                  groupList
                    .filter((g) => secretariatId === undefined || g.secretariatId === secretariatId)
                    .find((g) => g.groupId === id)
                }
                onChange={(group) => this.setState({ groupId: group.groupId })}
                allowEmpty={true}
              />
            </DivLine>
          </DivColumn>
          <DivColumn style={{ display: 'flex', alignItems: 'center' }}>
            <DivLine>
              <Checkbox style={{height: '100%', display: 'flex', alignItems: 'center'}}
                name="OneDay"
                checked={this.state.showAllEventTypes}
                onChange={(event) => this.setState({ showAllEventTypes: event.currentTarget.checked })}
              >
                <TranslatedMessage id={TLCode.SHOW_ALL_ENENT_TYPES} />
              </Checkbox>
            </DivLine>
          </DivColumn>
        </DivLine>
        <ButtonsContainer>
          <Button text={translate(TLCode.GENERAL_Search)} intent={Intent.PRIMARY} onClick={this.loadMessage} />
          <Button text={translate(TLCode.MESSAGE_NewMessage)} intent={Intent.PRIMARY} onClick={this.newMessage} />
          {/* {this.props.AuthenticationStore!.isSuperAdmin && (
            <Button text={translate(TLCode.MESSAGE_TestMessage)} intent={Intent.PRIMARY} onClick={this.testMessage} />
          )} */}
        </ButtonsContainer>
        <Cols>
          <Col>
            {isLoading ? (
              <SpinnerContainer>
                <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
              </SpinnerContainer>
            ) : (
              <>
                <DataGrid
                  dataSource={this.buildGridData()}
                  allowColumnReordering={true}
                  rowAlternationEnabled={true}
                  showBorders={true}
                  stateStoring={{
                    enabled: true,
                    type: 'sessionStorage',
                    storageKey: 'MessageTabV4Grid',
                  }}
                  //width="100%"
                  allowColumnResizing={true}
                  onExporting={this.onExporting}
                  columnResizingMode={'widget'}
                >
                  <Export enabled={true} texts={{ exportAll: translate(TLCode.GRID_EXCEL_EXPORT) }} />
                  <FilterRow visible={true} applyFilter={'auto'} />
                  <FilterPanel visible={true} />
                  <HeaderFilter visible={true} />
                  <GroupPanel visible={true} />
                  <SearchPanel visible={true} highlightCaseSensitive={true} />
                  <ColumnChooser enabled={true} />
                  <Column dataField="title" caption="message" dataType="string" />
                  <Column dataField="body" caption="message" dataType="string" />
                  <Column dataField="messageType" caption="type" dataType="string" alignment="left" width={80} />
                  <Column
                    dataField="messageCreatedOn"
                    caption="time"
                    dataType="date"
                    format="dd/MM/yyyy HH:mm:ss.SSS"
                    alignment="left"
                    sortOrder='desc'
                    width={140}
                  />
                  <Column
                    dataField="apbNumber"
                    caption="APB"
                    dataType="string"
                    alignment="left"
                    width={90}
                  />
                  <Column
                    dataField="recipientMailAddress"
                    caption="recipient"
                    dataType="string"
                    alignment="left"
                    width={200}
                  />
                  <Column
                    dataField="sendingEventId"
                    caption="event Id"
                    dataType="number"
                    alignment="left"
                    width={80}
                    visible={false}
                  />
                  <Column dataField="eventType" caption="event type" dataType="string" alignment="left" width={80} />
                  <Column dataField="type" caption="sub type" dataType="string" alignment="left" width={80} />
                  <Column
                    dataField="timestamp"
                    caption="time"
                    dataType="date"
                    format="dd/MM/yyyy HH:mm:ss"
                    alignment="left"
                    sortOrder='desc'
                    width={140}
                  />
                  <Column caption="Actions" type="buttons" width={120}>
                    <DGButton
                      text="Réexpédier"
                      hint="Réexpédier"
                      icon="email"
                      visible={true}
                      disabled={false}
                      onClick={onCloneIconClick}
                    />
                    &nbsp;&nbsp;
                    <DGButton
                      text="Montrer"
                      hint="Montrer"
                      icon="search"
                      visible={true}
                      disabled={false}
                      onClick={onShowBodyClick}
                    />
                  </Column>
                  <Pager
                    visible={true}
                    allowedPageSizes={[5, 10, 20, 50, 100]}
                    showPageSizeSelector={true}
                    showInfo={true}
                    showNavigationButtons={true}
                  />
                  <Paging defaultPageSize={20} />
                </DataGrid>
              </>
            )}
          </Col>
        </Cols>
        <MessageDialog
          isPreloaded={false}
          isOpen={this.state.isMessageDialogOpen}
          onClose={this.stopEdition}
          isTest={this.state.isTestMessage}
          save={this.save}
          pharmacyId={pharmacyId}
          secretariatId={this.props.secretariatId}
          pharmacyList={pharmacyList}
          groupList={groupList}
          translate={translate}
          isSecretariat={isSecretariat}
          canOutsideClickClose={false}
          canPreview={
            this.props.AuthenticationStore!.isAdmin ||
            this.props.AuthenticationStore!.isSuperAdmin ||
            this.props.AuthenticationStore!.isSecretariat
          }
          onPreviewClick={this.sendPreview}
        />
      </Container>
    );
  }
}

export default withTranslate(MessageTabV4);

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Cols = styled.div`
  display: flex;
  width: 100%
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

const Col = styled.div`
  display: flex;
  width: 50%
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  marginBottom: 5,
  '& button': {
    marginLeft: 5,
  },
});

const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;
